var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var _a;
import { BUILD_VERSION, BUSINESS_UNIT, cleanObject, deeplySetProperty, executeEvent, getFavoritesProps, hasEntitlementOverride, recursiveMerge, } from "./CommonHelper";
import { PAGE_NAME_PREFIX, PageNames, TEALIUM_EVENT_PREFIX, TealiumOnboardingActions, PAGE_PROPS_STORAGE, TealiumEventStrings, TealiumRedesignEvents, TrackEvents, } from "./Enums";
import { getLastAnonymousProfileId, setSegmentOptimizelyData, } from "./SegmentHelper";
var ALL_COLLECTIONS = PageNames.ALL_COLLECTIONS, CHANNEL = PageNames.CHANNEL, COLLECTION_ENTERTAINMENT = PageNames.COLLECTION_ENTERTAINMENT, COLLECTION_HOME = PageNames.COLLECTION_HOME, COLLECTION_LISTEN = PageNames.COLLECTION_LISTEN, COLLECTION_LIVE_TV = PageNames.COLLECTION_LIVE_TV, COLLECTION_LOCAL = PageNames.COLLECTION_LOCAL, COLLECTION_MOVIES = PageNames.COLLECTION_MOVIES, COLLECTION_NEWS = PageNames.COLLECTION_NEWS, COLLECTION_PERSONALITIES = PageNames.COLLECTION_PERSONALITIES, COLLECTION_SHOWS = PageNames.COLLECTION_SHOWS, COLLECTION_SPORTS = PageNames.COLLECTION_SPORTS, DETAIL = PageNames.DETAIL, FAVORITES_DETAIL = PageNames.FAVORITES_DETAIL, FAVORITES_LIVE = PageNames.FAVORITES_LIVE, FOOTER = PageNames.FOOTER, FX_CONFIRM_SUB = PageNames.FX_CONFIRM_SUB, FX_MARKETING = PageNames.FX_MARKETING, FX_MVPD_NO_SUPPORT = PageNames.FX_MVPD_NO_SUPPORT, HOME = PageNames.HOME, HOME_COLLECTIONS = PageNames.HOME_COLLECTIONS, LIVE = PageNames.LIVE, LIVE_SCHEDULE = PageNames.LIVE_SCHEDULE, MOVIES = PageNames.MOVIES, NETWORK_DETAIL = PageNames.NETWORK_DETAIL, NEWS = PageNames.NEWS, PLAYER = PageNames.PLAYER, PLAYER_COLLECTION = PageNames.PLAYER_COLLECTION, PLAYER_DETAIL = PageNames.PLAYER_DETAIL, PLAYER_GENERAL = PageNames.PLAYER_GENERAL, PROFILE_SIGN_IN = PageNames.PROFILE_SIGN_IN, PROFILE_SIGN_UP = PageNames.PROFILE_SIGN_UP, SEARCH = PageNames.SEARCH, SETTINGS = PageNames.SETTINGS, SIGN_IN = PageNames.SIGN_IN, SHOWS = PageNames.SHOWS;
var COLLECTION_IMPRESSION = TealiumRedesignEvents.COLLECTION_IMPRESSION, COLLECTION_ITEM_SELECT = TealiumRedesignEvents.COLLECTION_ITEM_SELECT, HERO_ITEM_SELECT = TealiumRedesignEvents.HERO_ITEM_SELECT;
var AUTHENTICATION_STARTED = TrackEvents.AUTHENTICATION_STARTED, ONBOARDING_START = TrackEvents.ONBOARDING_START, ON_FAVORITE = TrackEvents.ON_FAVORITE, ON_UNFAVORITE = TrackEvents.ON_UNFAVORITE, PERKS_PRESENTED = TrackEvents.PERKS_PRESENTED, PLAYER_IDLE_PROMPT = TrackEvents.PLAYER_IDLE_PROMPT, PLAYER_IDLE_PROMPT_CONFIRM = TrackEvents.PLAYER_IDLE_PROMPT_CONFIRM, PREVIEW_PASS_EXPIRED = TrackEvents.PREVIEW_PASS_EXPIRED, PREVIEW_PASS_STARTED = TrackEvents.PREVIEW_PASS_STARTED, SCHEDULE_RESTART = TrackEvents.SCHEDULE_RESTART, SCHEDULE_WATCH_LIVE = TrackEvents.SCHEDULE_WATCH_LIVE, SIGN_IN_COMPLETED = TrackEvents.SIGN_IN_COMPLETED, SIGN_IN_ERROR = TrackEvents.SIGN_IN_ERROR, SIGN_IN_FORGOT_PASSWORD_STARTED = TrackEvents.SIGN_IN_FORGOT_PASSWORD_STARTED, SIGN_IN_INCOMPLETE = TrackEvents.SIGN_IN_INCOMPLETE, SIGN_IN_STARTED = TrackEvents.SIGN_IN_STARTED, SIGN_OUT_COMPLETED = TrackEvents.SIGN_OUT_COMPLETED, SIGN_UP_COMPLETED = TrackEvents.SIGN_UP_COMPLETED, SIGN_UP_ERROR = TrackEvents.SIGN_UP_ERROR, SIGN_UP_INCOMPLETE = TrackEvents.SIGN_UP_INCOMPLETE, SIGN_UP_STARTED = TrackEvents.SIGN_UP_STARTED;
export var eventPageTypes = (_a = {},
    _a[ALL_COLLECTIONS] = "all collections",
    _a[CHANNEL] = "channel",
    _a[COLLECTION_ENTERTAINMENT] = "entertainment",
    _a[COLLECTION_HOME] = "home",
    _a[COLLECTION_LISTEN] = "listen",
    _a[COLLECTION_LIVE_TV] = "live tv",
    _a[COLLECTION_LOCAL] = "local",
    _a[COLLECTION_MOVIES] = "movies",
    _a[COLLECTION_NEWS] = "news",
    _a[COLLECTION_PERSONALITIES] = "personalities",
    _a[COLLECTION_SHOWS] = "shows",
    _a[COLLECTION_SPORTS] = "sports",
    _a[DETAIL] = "detail",
    _a[FAVORITES_DETAIL] = "detail page",
    _a[FAVORITES_LIVE] = "live page",
    _a[FOOTER] = "footer page",
    _a[FX_CONFIRM_SUB] = "fxpl confirm subscription",
    _a[FX_MARKETING] = "fxpl landing",
    _a[FX_MVPD_NO_SUPPORT] = "fxpl confirm subscription",
    _a[HOME] = "home",
    _a[HOME_COLLECTIONS] = "collections",
    _a[LIVE] = "live tv",
    _a[LIVE_SCHEDULE] = "livetv:schedule",
    _a[MOVIES] = "movies",
    _a[NETWORK_DETAIL] = "network",
    _a[NEWS] = "news",
    _a[PLAYER] = "player",
    _a[PLAYER_COLLECTION] = "collection:player",
    _a[PLAYER_DETAIL] = "detail:player",
    _a[PLAYER_GENERAL] = "general:player",
    _a[PROFILE_SIGN_IN] = "account:profile sign in",
    _a[PROFILE_SIGN_UP] = "account:profile sign up",
    _a[SETTINGS] = "settings",
    _a[SIGN_IN] = "sign-in",
    _a[SHOWS] = "shows",
    _a);
var PATH_GLOBAL = "context.tealium";
var SOURCE_COLLECTION = PATH_GLOBAL + ".source.collection";
export var SOURCE_COLLECTION_TYPE = SOURCE_COLLECTION + ".type";
export var SOURCE_COLLECTION_TITLE = SOURCE_COLLECTION + ".title";
export var SOURCE_COLLECTION_ITEMS = SOURCE_COLLECTION + ".items";
export var SOURCE_COLLECTION_SELECTED_ITEM = SOURCE_COLLECTION + ".selectedItem";
export var SOURCE_IS_SHOW = PATH_GLOBAL + ".source.isShow";
export var SOURCE_AUTH = PATH_GLOBAL + ".source.auth";
export var SOURCE_PROFILE_START = PATH_GLOBAL + ".source.profileStart";
export var callContextEvent = function (action, network) {
    var _a, _b, _c;
    var sFallback = window.s_analytics;
    var s = (_a = window.s) !== null && _a !== void 0 ? _a : sFallback;
    if (s && network) {
        var networkMappingConfig = (_b = window.ExternalConfig) === null || _b === void 0 ? void 0 : _b.epgNetworkLogoMapping;
        var livestreamNetwork = (_c = networkMappingConfig === null || networkMappingConfig === void 0 ? void 0 : networkMappingConfig.network) === null || _c === void 0 ? void 0 : _c.toLowerCase();
        var linkTrackLocationArr = [
            "contextData.page.action",
            "contextData.page.livestream_network",
        ];
        s.contextData = {
            "page.action": action,
            "page.livestream_network": livestreamNetwork,
        };
        s.linkTrackVars = linkTrackLocationArr.join(",");
        s.tl(true, "o", action);
    }
};
function IEcustomEventPolyfill(lclEvent, params) {
    var lclParams = {
        bubbles: false,
        cancelable: false,
        detail: params.detail,
    };
    var evt = document.createEvent("CustomEvent");
    evt.initCustomEvent(lclEvent, lclParams.bubbles, lclParams.cancelable, lclParams.detail);
    return evt;
}
export var callEvent = function (name, data) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    if (data === void 0) { data = {}; }
    var isTrackingEnabled = isTrackingEnabledForEvent(name);
    var user_xid = (_a = window.DataLayer) === null || _a === void 0 ? void 0 : _a.getLocalStorage({ key: "xid" });
    if (!name || !isTrackingEnabled)
        return null;
    var defaultProps = {
        last_anonymous_profile_id: getLastAnonymousProfileId(),
        user_xid: user_xid,
        app_build: BuildNumber,
        app_name: (_d = (_c = (_b = window.ExternalConfig) === null || _b === void 0 ? void 0 : _b.analytics) === null || _c === void 0 ? void 0 : _c.app_name) !== null && _d !== void 0 ? _d : "foxnow",
        app_platform: (_g = (_f = (_e = window.ExternalConfig) === null || _e === void 0 ? void 0 : _e.analytics) === null || _f === void 0 ? void 0 : _f.app_platform) !== null && _g !== void 0 ? _g : "web",
        app_version: Version,
        primary_business_unit: (_k = (_j = (_h = window.ExternalConfig) === null || _h === void 0 ? void 0 : _h.analytics) === null || _j === void 0 ? void 0 : _j.primary_business_unit) !== null && _k !== void 0 ? _k : "fng",
        secondary_business_unit: (_o = (_m = (_l = window.ExternalConfig) === null || _l === void 0 ? void 0 : _l.brand) === null || _m === void 0 ? void 0 : _m.businessUnit) !== null && _o !== void 0 ? _o : "fox",
    };
    var eventPayload = __assign(__assign({}, data), defaultProps);
    if (typeof window.CustomEvent !== "function") {
        IEcustomEventPolyfill.prototype = window.Event.prototype;
        window.CustomEvent =
            IEcustomEventPolyfill;
    }
    // TODO: remove and refactore the file and fix tests once we got confirmation from Michael DeLa Cruz for Adobe/Tealium cut off
    var ev = new window.CustomEvent(name, { detail: eventPayload });
    var silenceLogOutput = (_p = window.DataLayer) === null || _p === void 0 ? void 0 : _p.isTestEnvironment();
    if (!silenceLogOutput)
        console.debug("Dispatching tealium events", name, { detail: eventPayload });
    return document.dispatchEvent(ev);
};
// TODO: split this function up
export var callPageView = function (_a) {
    var account = _a.account, cb = _a.cb, collection = _a.collection, domain = _a.domain, footerType = _a.footerType, isFounders = _a.isFounders, isFreemium = _a.isFreemium, networkEntitlementList = _a.networkEntitlementList, pageName = _a.pageName, pageTitle = _a.pageTitle, detailType = _a.pageType, panelExperimentData = _a.panelExperimentData, provider = _a.provider, seriesType = _a.seriesType, useUtagGlobal = _a.useUtagGlobal;
    return __awaiter(void 0, void 0, void 0, function () {
        var providerCookie, cookieProviderName, collectionType, collectionTitleFallback, collectionTitle, pTitle, cLength, eventPageType, cType, pageType, videoIdx, video, videoSeriesType, sport, matchup, homeTeam, awayTeam, sportsData, cTitleOriginal, cTitle, eventPageName, favData, defaultProviderName, providerName, mvpd, isAuthenticated, authenticatedText, profileId, optimizelyExperimentData, experimentData, preauthorizedResources, validEntitlements, entitlements, formattedEntitlements, noEntitlementsString, userEntitlements, entitlementOverride, name, storagePageName, storagePageType, localStoragePageProps, page_name, page_type, last_anonymous_profile_id, data, utagData, scriptLoaded, pageName_1, callSign, favData_1, eventData;
        var _b;
        var _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26;
        return __generator(this, function (_27) {
            switch (_27.label) {
                case 0:
                    providerCookie = (_c = window.DataLayer) === null || _c === void 0 ? void 0 : _c.getCookie({
                        name: (_e = (_d = window.DataLayer.enums) === null || _d === void 0 ? void 0 : _d.MVPD_COOKIE) !== null && _e !== void 0 ? _e : "",
                    });
                    cookieProviderName = (_f = window.DataLayer) === null || _f === void 0 ? void 0 : _f.getMVPD();
                    collectionType = collection === null || collection === void 0 ? void 0 : collection.collectionType;
                    collectionTitleFallback = collection === null || collection === void 0 ? void 0 : collection.name;
                    collectionTitle = (_g = collection === null || collection === void 0 ? void 0 : collection.headline) !== null && _g !== void 0 ? _g : collectionTitleFallback;
                    pTitle = (_h = collection === null || collection === void 0 ? void 0 : collection.pageTitle) !== null && _h !== void 0 ? _h : pageTitle;
                    cLength = (_o = (_m = (_j = collection === null || collection === void 0 ? void 0 : collection.collectionLength) !== null && _j !== void 0 ? _j : (_l = (_k = collection === null || collection === void 0 ? void 0 : collection.items) === null || _k === void 0 ? void 0 : _k.member) === null || _l === void 0 ? void 0 : _l.length) !== null && _m !== void 0 ? _m : collection === null || collection === void 0 ? void 0 : collection.totalItems) !== null && _o !== void 0 ? _o : 0;
                    eventPageType = (_p = eventPageTypes[pageName]) !== null && _p !== void 0 ? _p : "default";
                    cType = collectionType || "no collection type";
                    if (cType === "network")
                        cType = collectionType + "-" + BUSINESS_UNIT;
                    videoIdx = (_q = collection === null || collection === void 0 ? void 0 : collection.selectedItem) !== null && _q !== void 0 ? _q : 0;
                    video = (_t = (_s = (_r = collection === null || collection === void 0 ? void 0 : collection.items) === null || _r === void 0 ? void 0 : _r.member) === null || _s === void 0 ? void 0 : _s[videoIdx]) !== null && _t !== void 0 ? _t : null;
                    videoSeriesType = (_u = video === null || video === void 0 ? void 0 : video.seriesType) !== null && _u !== void 0 ? _u : null;
                    sport = "none";
                    matchup = "none";
                    if (videoSeriesType === "sportingEvent") {
                        sport = (_v = video === null || video === void 0 ? void 0 : video.sportTag) !== null && _v !== void 0 ? _v : sport;
                        matchup = (_w = video === null || video === void 0 ? void 0 : video.name) !== null && _w !== void 0 ? _w : "none";
                    }
                    homeTeam = (_x = video === null || video === void 0 ? void 0 : video.home_team) !== null && _x !== void 0 ? _x : "none";
                    awayTeam = (_y = video === null || video === void 0 ? void 0 : video.away_team) !== null && _y !== void 0 ? _y : "none";
                    sportsData = ((_z = window.DataLayer) === null || _z === void 0 ? void 0 : _z.getSportsFeatures())
                        ? { sport: sport, matchup: matchup, homeTeam: homeTeam, awayTeam: awayTeam }
                        : {};
                    cTitleOriginal = collectionTitle || null;
                    cTitle = (cTitleOriginal || "").toLowerCase();
                    eventPageName = getEventPageName({
                        pageName: pageName,
                        collectionType: cType,
                        collectionTitle: cTitle,
                        pageType: eventPageType,
                        pageTitle: pTitle,
                        seriesType: seriesType,
                        footerType: footerType,
                    });
                    favData = getFavoritesData();
                    defaultProviderName = provider === null || provider === void 0 ? void 0 : provider.adobePassId;
                    providerName = defaultProviderName || cookieProviderName;
                    mvpd = providerName || "no mvpd";
                    isAuthenticated = providerName && !((_0 = window.DataLayer) === null || _0 === void 0 ? void 0 : _0.isPreviewPass(providerName));
                    authenticatedText = isAuthenticated
                        ? "authenticated"
                        : "not authenticated";
                    profileId = account === null || account === void 0 ? void 0 : account.profileId;
                    optimizelyExperimentData = getOptimizelyExperimentData();
                    experimentData = function () {
                        var experiments = [];
                        if (optimizelyExperimentData)
                            experiments.push(optimizelyExperimentData);
                        if (panelExperimentData)
                            experiments.push(panelExperimentData);
                        if (experiments.length > 0) {
                            var experimentString = experiments.join(",");
                            // Set utag to avoid null values for nested objects
                            deeplySetProperty(window, "utag_data.user.testname", experimentString);
                            return experimentString;
                        }
                        return null;
                    };
                    preauthorizedResources = defaultProviderName
                        ? networkEntitlementList
                        : providerCookie === null || providerCookie === void 0 ? void 0 : providerCookie.preauthorizedResources;
                    validEntitlements = preauthorizedResources && isAuthenticated;
                    entitlements = EnableAnalyticsEntitlementFix
                        ? validEntitlements
                        : preauthorizedResources;
                    formattedEntitlements = entitlements
                        ? preauthorizedResources.sort().join()
                        : "";
                    noEntitlementsString = ((_2 = (_1 = window.ExternalConfig) === null || _1 === void 0 ? void 0 : _1.analytics) === null || _2 === void 0 ? void 0 : _2.app_name) === "foxnation"
                        ? "foxnation"
                        : "no entitlements";
                    userEntitlements = formattedEntitlements.length > 0
                        ? formattedEntitlements
                        : noEntitlementsString;
                    entitlementOverride = hasEntitlementOverride();
                    if (entitlementOverride)
                        userEntitlements = entitlementOverride;
                    switch (pageName) {
                        case ALL_COLLECTIONS:
                        case HOME:
                        case MOVIES:
                        case NEWS:
                        case SHOWS:
                            pageType = eventPageTypes[pageName];
                            break;
                        case COLLECTION_ENTERTAINMENT:
                        case COLLECTION_HOME:
                        case COLLECTION_LIVE_TV:
                        case COLLECTION_LISTEN:
                        case COLLECTION_LOCAL:
                        case COLLECTION_MOVIES:
                        case COLLECTION_NEWS:
                        case COLLECTION_PERSONALITIES:
                        case COLLECTION_SHOWS:
                        case COLLECTION_SPORTS:
                            pageType = eventPageTypes[pageName];
                            eventPageType = "section_landing";
                            break;
                        case PLAYER_COLLECTION:
                            pageType = "player:collection";
                            break;
                        case PLAYER_DETAIL:
                            pageType = "player:detail";
                            break;
                        case PLAYER:
                        case PLAYER_GENERAL:
                            pageType = "player";
                            break;
                        case PROFILE_SIGN_IN:
                            pageType = "profile sign in";
                            break;
                        case PROFILE_SIGN_UP:
                            pageType = "profile sign up";
                            break;
                        case SEARCH:
                            pageType = "find:section-front";
                            break;
                        case SETTINGS:
                            pageType = "settings:section-front";
                            break;
                        case CHANNEL:
                            pageType = "channel";
                            eventPageType = "channel_page_landing";
                            break;
                        case DETAIL:
                            pageType = "detail";
                            if ((_3 = window.DataLayer) === null || _3 === void 0 ? void 0 : _3.isNation())
                                eventPageType = "detail_menu";
                            break;
                        case LIVE:
                            pageType = "live tv";
                            break;
                        case FX_MARKETING:
                            pageType = "fxpl landing";
                            break;
                        case FX_CONFIRM_SUB:
                            pageType = "fxpl confirm subscription";
                            break;
                        case FX_MVPD_NO_SUPPORT:
                            pageType = "fxpl mvpd no support";
                            break;
                        case FOOTER:
                            pageType = "footer page";
                            break;
                        default:
                            pageType = "collection:" + cType;
                            break;
                    }
                    name = "analytics_pv_" + eventPageType;
                    if (detailType)
                        pageType = detailType;
                    if (pageName === PLAYER) {
                        localStoragePageProps = (_4 = window.DataLayer) === null || _4 === void 0 ? void 0 : _4.getLocalStorage({
                            key: PAGE_PROPS_STORAGE,
                        });
                        if (localStoragePageProps && (document === null || document === void 0 ? void 0 : document.referrer.includes(domain)))
                            _b = __read(localStoragePageProps.split("/"), 2), storagePageName = _b[0], storagePageType = _b[1];
                    }
                    else {
                        (_5 = window.DataLayer) === null || _5 === void 0 ? void 0 : _5.setLocalStorage({
                            key: PAGE_PROPS_STORAGE,
                            value: eventPageName + "/" + pageType,
                        });
                    }
                    page_name = storagePageName || eventPageName;
                    page_type = storagePageType || pageType;
                    last_anonymous_profile_id = getLastAnonymousProfileId();
                    data = cleanObject(__assign({ app_build: BuildNumber, app_name: (_8 = (_7 = (_6 = window.ExternalConfig) === null || _6 === void 0 ? void 0 : _6.analytics) === null || _7 === void 0 ? void 0 : _7.app_name) !== null && _8 !== void 0 ? _8 : "foxnow", app_platform: (_11 = (_10 = (_9 = window.ExternalConfig) === null || _9 === void 0 ? void 0 : _9.analytics) === null || _10 === void 0 ? void 0 : _10.app_platform) !== null && _11 !== void 0 ? _11 : "web", app_version: Version, authentication_state: authenticatedText, business_unit: "" + BUSINESS_UNIT, collection_length: cLength, collection_title: cTitle, collection_type: cType, dcg_profile_id: profileId, favorites_content_length: favData.count, favorites_content_list: favData.list, isFreemium: isFreemium,
                        last_anonymous_profile_id: last_anonymous_profile_id,
                        mvpd: mvpd, network_entitlement_list: userEntitlements, page_name: page_name,
                        page_type: page_type, primary_business_unit: (_14 = (_13 = (_12 = window.ExternalConfig) === null || _12 === void 0 ? void 0 : _12.analytics) === null || _13 === void 0 ? void 0 : _13.primary_business_unit) !== null && _14 !== void 0 ? _14 : "fng", platform_version: BUILD_VERSION, secondary_business_unit: (_17 = (_16 = (_15 = window.ExternalConfig) === null || _15 === void 0 ? void 0 : _15.brand) === null || _16 === void 0 ? void 0 : _16.businessUnit) !== null && _17 !== void 0 ? _17 : "fox", user: {
                            last_anonymous_profile_id: last_anonymous_profile_id,
                            testname: (_21 = (_18 = experimentData()) !== null && _18 !== void 0 ? _18 : (_20 = (_19 = window.context) === null || _19 === void 0 ? void 0 : _19.optimizely) === null || _20 === void 0 ? void 0 : _20.pageTestName) !== null && _21 !== void 0 ? _21 : null,
                            network_entitlement_list: userEntitlements,
                            entitlement_list: userEntitlements,
                        } }, sportsData));
                    // Nation Specific Vars
                    // Default is_founders to false
                    if ((_22 = window.DataLayer) === null || _22 === void 0 ? void 0 : _22.isNation())
                        data.is_founders = isFounders || "false";
                    utagData = (_23 = window.utag_data) !== null && _23 !== void 0 ? _23 : {};
                    if (!useUtagGlobal) return [3 /*break*/, 2];
                    // set utag_data early so it can be accessed before isTealiumLoaded finishes
                    deeplySetProperty(window, "utag_data", recursiveMerge(utagData, data));
                    scriptLoaded = function () { return __awaiter(void 0, void 0, void 0, function () {
                        var utag, firstEvent, initEvent, params, error_1;
                        var _a;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    _b.trys.push([0, 2, , 3]);
                                    return [4 /*yield*/, isTealiumLoaded()];
                                case 1:
                                    _b.sent();
                                    utag = window.utag;
                                    firstEvent = (_a = window.utag) === null || _a === void 0 ? void 0 : _a.view;
                                    initEvent = firstEvent.bind(utag);
                                    params = __assign({ tealium_event: name }, data);
                                    // TODO: remove and refactore the file and fix tests once we got confirmation from Michael DeLa Cruz for Adobe/Tealium cut off
                                    initEvent(params, cb);
                                    return [3 /*break*/, 3];
                                case 2:
                                    error_1 = _b.sent();
                                    console.error("Tealium Error:", error_1);
                                    return [3 /*break*/, 3];
                                case 3: return [2 /*return*/];
                            }
                        });
                    }); };
                    return [4 /*yield*/, scriptLoaded()];
                case 1:
                    _27.sent();
                    return [3 /*break*/, 3];
                case 2:
                    if (eventPageType !== "default") {
                        pageName_1 = page_name;
                        callSign = (_25 = (_24 = window.utag_data) === null || _24 === void 0 ? void 0 : _24.call_sign) !== null && _25 !== void 0 ? _25 : null;
                        if (callSign) {
                            pageName_1 = pageName_1 + ":" + callSign;
                            if (!pageName_1.includes(eventPageTypes[LIVE]))
                                deeplySetProperty(window, "utag_data.call_sign", null);
                        }
                        favData_1 = getFavoritesData();
                        deeplySetProperty(window, "utag_data", recursiveMerge(utagData, {
                            favorites_content_length: favData_1.count,
                            favorites_content_list: favData_1.list,
                            page_name: pageName_1,
                            page_type: page_type,
                        }));
                    }
                    eventData = data;
                    if (pageName === PLAYER) {
                        eventData = __assign(__assign({}, data), ((_26 = window.utag_data) !== null && _26 !== void 0 ? _26 : {}));
                    }
                    callEvent(name, eventData);
                    Promise.resolve(eventData);
                    _27.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    });
};
export var fireRedesignEvent = function (_a) {
    var _b, _c, _d;
    var account = _a.account, params = _a.params, action = _a.action;
    var path = (_b = window === null || window === void 0 ? void 0 : window.location) === null || _b === void 0 ? void 0 : _b.pathname;
    var profileId = account === null || account === void 0 ? void 0 : account.profileId;
    var data = setProfileId(profileId, __assign({ page_name: (_c = window === null || window === void 0 ? void 0 : window.utag_data) === null || _c === void 0 ? void 0 : _c.page_name, page_type: (_d = window === null || window === void 0 ? void 0 : window.utag_data) === null || _d === void 0 ? void 0 : _d.page_type }, params));
    callEvent("" + TEALIUM_EVENT_PREFIX + action, data);
};
export var getAccountEvents = function (_a) {
    var _b;
    var profileId = _a.profileId;
    return (_b = {},
        _b[AUTHENTICATION_STARTED] = function (props) {
            var _a, _b;
            var action = "authentication_start";
            var data = setProfileId(profileId, __assign({ page_name: (_a = window === null || window === void 0 ? void 0 : window.utag_data) === null || _a === void 0 ? void 0 : _a.page_name, page_type: (_b = window === null || window === void 0 ? void 0 : window.utag_data) === null || _b === void 0 ? void 0 : _b.page_type }, props));
            callEvent("" + TEALIUM_EVENT_PREFIX + action, data);
        },
        _b[PERKS_PRESENTED] = function (_a) {
            var _b, _c;
            var utagAccountSource = _a.utagAccountSource;
            var action = "profile_prompt";
            var data = setProfileId(profileId, {
                action: action,
                profile_start_source: utagAccountSource,
                onboarding_start_source: utagAccountSource,
                platform_version: BUILD_VERSION,
                onboarding_action: TealiumOnboardingActions.COMPLETE,
                page_name: (_b = window === null || window === void 0 ? void 0 : window.utag_data) === null || _b === void 0 ? void 0 : _b.page_name,
                page_type: (_c = window === null || window === void 0 ? void 0 : window.utag_data) === null || _c === void 0 ? void 0 : _c.page_type,
            });
            callEvent("" + TEALIUM_EVENT_PREFIX + action, data);
        },
        _b[ONBOARDING_START] = function (_a) {
            var _b, _c;
            var utagAccountSource = _a.utagAccountSource;
            var action = "onboarding_start";
            var data = setProfileId(profileId, {
                action: action,
                platform_version: BUILD_VERSION,
                onboarding_start_source: utagAccountSource,
                page_name: (_b = window === null || window === void 0 ? void 0 : window.utag_data) === null || _b === void 0 ? void 0 : _b.page_name,
                page_type: (_c = window === null || window === void 0 ? void 0 : window.utag_data) === null || _c === void 0 ? void 0 : _c.page_type,
            });
            callEvent("" + TEALIUM_EVENT_PREFIX + action, data);
        },
        _b[ON_FAVORITE] = function (_a) {
            var _b, _c;
            var location = _a.location;
            var action = "added_favorites";
            var favData = getFavoritesData();
            var data = setProfileId(profileId, {
                action: action,
                platform_version: BUILD_VERSION,
                favorites_content_length: favData.count,
                favorites_content_list: favData.list,
                favorites_location: location,
                page_name: (_b = window === null || window === void 0 ? void 0 : window.utag_data) === null || _b === void 0 ? void 0 : _b.page_name,
                page_type: (_c = window === null || window === void 0 ? void 0 : window.utag_data) === null || _c === void 0 ? void 0 : _c.page_type,
            });
            callEvent("" + TEALIUM_EVENT_PREFIX + action, data);
        },
        _b[ON_UNFAVORITE] = function (_a) {
            var _b, _c;
            var location = _a.location;
            var action = "removed_favorites";
            var favData = getFavoritesData();
            var data = setProfileId(profileId, {
                action: action,
                platform_version: BUILD_VERSION,
                favorites_content_length: favData.count,
                favorites_content_list: favData.list,
                favorites_location: location,
                page_name: (_b = window === null || window === void 0 ? void 0 : window.utag_data) === null || _b === void 0 ? void 0 : _b.page_name,
                page_type: (_c = window === null || window === void 0 ? void 0 : window.utag_data) === null || _c === void 0 ? void 0 : _c.page_type,
            });
            callEvent("" + TEALIUM_EVENT_PREFIX + action, data);
        },
        _b[SIGN_IN_COMPLETED] = function (_a) {
            var _b, _c;
            var utagAccountSource = _a.utagAccountSource;
            var action = "profile_login_complete";
            var data = setProfileId(profileId, {
                action: action,
                platform_version: BUILD_VERSION,
                profile_start_source: utagAccountSource,
                profile_type: "general",
                onboarding_start_source: utagAccountSource,
                onboarding_action: TealiumOnboardingActions.COMPLETE,
                page_name: (_b = window === null || window === void 0 ? void 0 : window.utag_data) === null || _b === void 0 ? void 0 : _b.page_name,
                page_type: (_c = window === null || window === void 0 ? void 0 : window.utag_data) === null || _c === void 0 ? void 0 : _c.page_type,
            });
            callEvent("" + TEALIUM_EVENT_PREFIX + action, data);
        },
        _b[SIGN_IN_ERROR] = function (_a) {
            var _b, _c;
            var utagAccountSource = _a.utagAccountSource;
            var action = "profile_login_error";
            var data = setProfileId(profileId, {
                action: action,
                profile_start_source: utagAccountSource,
                page_name: (_b = window === null || window === void 0 ? void 0 : window.utag_data) === null || _b === void 0 ? void 0 : _b.page_name,
                page_type: (_c = window === null || window === void 0 ? void 0 : window.utag_data) === null || _c === void 0 ? void 0 : _c.page_type,
            });
            callEvent("" + TEALIUM_EVENT_PREFIX + action, data);
        },
        _b[SIGN_IN_FORGOT_PASSWORD_STARTED] = function (_a) {
            var _b, _c;
            var utagAccountSource = _a.utagAccountSource;
            var action = "profile_login_forgot_pw";
            var data = setProfileId(profileId, {
                action: action,
                profile_start_source: utagAccountSource,
                page_name: (_b = window === null || window === void 0 ? void 0 : window.utag_data) === null || _b === void 0 ? void 0 : _b.page_name,
                page_type: (_c = window === null || window === void 0 ? void 0 : window.utag_data) === null || _c === void 0 ? void 0 : _c.page_type,
            });
            callEvent("" + TEALIUM_EVENT_PREFIX + action, data);
        },
        _b[SIGN_IN_INCOMPLETE] = function (_a) {
            var _b, _c;
            var utagAccountSource = _a.utagAccountSource;
            var action = "profile_login_incomplete";
            var data = setProfileId(profileId, {
                action: action,
                profile_start_source: utagAccountSource,
                page_name: (_b = window === null || window === void 0 ? void 0 : window.utag_data) === null || _b === void 0 ? void 0 : _b.page_name,
                page_type: (_c = window === null || window === void 0 ? void 0 : window.utag_data) === null || _c === void 0 ? void 0 : _c.page_type,
            });
            callEvent("" + TEALIUM_EVENT_PREFIX + action, data);
        },
        _b[SIGN_IN_STARTED] = function (_a) {
            var _b, _c;
            var utagAccountSource = _a.utagAccountSource, onboardingAction = _a.onboardingAction;
            var action = "profile_login_start";
            var data = setProfileId(profileId, {
                action: action,
                platform_version: BUILD_VERSION,
                profile_start_source: utagAccountSource,
                onboarding_start_source: utagAccountSource,
                onboarding_action: onboardingAction,
                page_name: (_b = window === null || window === void 0 ? void 0 : window.utag_data) === null || _b === void 0 ? void 0 : _b.page_name,
                page_type: (_c = window === null || window === void 0 ? void 0 : window.utag_data) === null || _c === void 0 ? void 0 : _c.page_type,
            });
            callEvent("" + TEALIUM_EVENT_PREFIX + action, data);
        },
        _b[SIGN_OUT_COMPLETED] = function () {
            var _a, _b;
            var action = "profile_logout";
            var data = setProfileId(profileId, {
                action: action,
                page_name: (_a = window === null || window === void 0 ? void 0 : window.utag_data) === null || _a === void 0 ? void 0 : _a.page_name,
                page_type: (_b = window === null || window === void 0 ? void 0 : window.utag_data) === null || _b === void 0 ? void 0 : _b.page_type,
            });
            callEvent("" + TEALIUM_EVENT_PREFIX + action, data);
        },
        _b[SIGN_UP_COMPLETED] = function (_a) {
            var _b, _c;
            var newsLetter = _a.newsLetter, utagAccountSource = _a.utagAccountSource;
            var action = "profile_signup_complete";
            var data = setProfileId(profileId, {
                action: action,
                platform_version: BUILD_VERSION,
                profile_start_source: utagAccountSource,
                profile_type: "general",
                newsletter_opt_in: newsLetter,
                onboarding_start_source: utagAccountSource,
                onboarding_action: TealiumOnboardingActions.COMPLETE,
                page_name: (_b = window === null || window === void 0 ? void 0 : window.utag_data) === null || _b === void 0 ? void 0 : _b.page_name,
                page_type: (_c = window === null || window === void 0 ? void 0 : window.utag_data) === null || _c === void 0 ? void 0 : _c.page_type,
            });
            callEvent("" + TEALIUM_EVENT_PREFIX + action, data);
        },
        _b[SIGN_UP_ERROR] = function (_a) {
            var _b, _c;
            var utagAccountSource = _a.utagAccountSource;
            var action = "profile_signup_error";
            var data = setProfileId(profileId, {
                action: action,
                profile_start_source: utagAccountSource,
                page_name: (_b = window === null || window === void 0 ? void 0 : window.utag_data) === null || _b === void 0 ? void 0 : _b.page_name,
                page_type: (_c = window === null || window === void 0 ? void 0 : window.utag_data) === null || _c === void 0 ? void 0 : _c.page_type,
            });
            callEvent("" + TEALIUM_EVENT_PREFIX + action, data);
        },
        _b[SIGN_UP_INCOMPLETE] = function (_a) {
            var _b, _c;
            var utagAccountSource = _a.utagAccountSource;
            var action = "profile_signup_incomplete";
            var data = setProfileId(profileId, {
                action: action,
                profile_start_source: utagAccountSource,
                page_name: (_b = window === null || window === void 0 ? void 0 : window.utag_data) === null || _b === void 0 ? void 0 : _b.page_name,
                page_type: (_c = window === null || window === void 0 ? void 0 : window.utag_data) === null || _c === void 0 ? void 0 : _c.page_type,
            });
            callEvent("" + TEALIUM_EVENT_PREFIX + action, data);
        },
        _b[SIGN_UP_STARTED] = function (_a) {
            var _b, _c;
            var utagAccountSource = _a.utagAccountSource, onboardingAction = _a.onboardingAction;
            var action = "profile_signup_start";
            var data = setProfileId(profileId, {
                action: action,
                platform_version: BUILD_VERSION,
                profile_start_source: utagAccountSource,
                onboarding_start_source: utagAccountSource,
                onboarding_action: onboardingAction,
                page_name: (_b = window === null || window === void 0 ? void 0 : window.utag_data) === null || _b === void 0 ? void 0 : _b.page_name,
                page_type: (_c = window === null || window === void 0 ? void 0 : window.utag_data) === null || _c === void 0 ? void 0 : _c.page_type,
            });
            callEvent("" + TEALIUM_EVENT_PREFIX + action, data);
        },
        _b);
};
export var getAuthStartSource = function (_a) {
    var networkUpsellPage = _a.networkUpsellPage, pathname = _a.pathname;
    if (pathname.replace(/\//g, "") === networkUpsellPage.replace(/\//g, "")) {
        return "marketing_page";
    }
    if (pathname === "/") {
        return "home";
    }
    return "series_detail_page";
};
// FXBT Helper: Get name of current brand logo
export var getCurrentBrand = function () {
    var _a;
    var headerLogo = ((_a = window.ExternalConfig) === null || _a === void 0 ? void 0 : _a.brand).headerLogo;
    if (headerLogo === "fxpl-beta" || headerLogo === "fxpl")
        return "fx+";
    return headerLogo;
};
export var getDetailTabData = function (_a) {
    var _b, _c;
    var seriesData = _a.seriesData, tab = _a.tab;
    var seriesType = seriesData === null || seriesData === void 0 ? void 0 : seriesData.seriesType;
    var pageTitle = seriesData === null || seriesData === void 0 ? void 0 : seriesData.name;
    var collectionLength;
    var name;
    if (tab) {
        collectionLength = (_b = tab === null || tab === void 0 ? void 0 : tab.hasParts) === null || _b === void 0 ? void 0 : _b.length;
        name = (_c = window.DataLayer) === null || _c === void 0 ? void 0 : _c.getDetailTabName({ tab: tab, seriesType: seriesType });
    }
    return {
        name: name,
        selectedMenuItem: name,
        collectionType: seriesType,
        collectionLength: collectionLength,
        pageTitle: pageTitle,
    };
};
export var getEventPageName = function (_a) {
    var pageName = _a.pageName, pageType = _a.pageType, collectionType = _a.collectionType, collectionTitle = _a.collectionTitle, pageTitle = _a.pageTitle, seriesType = _a.seriesType, footerType = _a.footerType;
    switch (pageName) {
        case COLLECTION_ENTERTAINMENT:
        case COLLECTION_HOME:
        case COLLECTION_LISTEN:
        case COLLECTION_LIVE_TV:
        case COLLECTION_LOCAL:
        case COLLECTION_MOVIES:
        case COLLECTION_NEWS:
        case COLLECTION_PERSONALITIES:
        case COLLECTION_SHOWS:
        case COLLECTION_SPORTS:
        case HOME_COLLECTIONS:
            return PAGE_NAME_PREFIX + ":" + pageType + ":landing";
        case CHANNEL:
            return PAGE_NAME_PREFIX + ":" + pageType + ":" + pageTitle;
        case HOME:
        case LIVE:
        case NEWS:
            return PAGE_NAME_PREFIX + ":" + pageType + ":landing";
        case ALL_COLLECTIONS:
        case FX_MARKETING:
        case FX_CONFIRM_SUB:
        case MOVIES:
        case SHOWS:
        case SIGN_IN:
            return PAGE_NAME_PREFIX + ":" + eventPageTypes[pageName];
        case FX_MVPD_NO_SUPPORT:
            return PAGE_NAME_PREFIX + ":fxpl mvpd no support";
        case DETAIL:
        case NETWORK_DETAIL:
            return PAGE_NAME_PREFIX + ":" + pageType + ":" + seriesType + ":" + pageTitle;
        case FOOTER:
            return PAGE_NAME_PREFIX + ":" + pageType + ":" + footerType;
        case SEARCH:
            return PAGE_NAME_PREFIX + ":find:landing";
        default:
            return PAGE_NAME_PREFIX + ":" + pageType;
    }
};
export var getFavoritesData = function () {
    var _a;
    var _b = getFavoritesProps((_a = window.DataLayer) === null || _a === void 0 ? void 0 : _a.getFavorites()), _c = _b.favorites_content_length, favorites_content_length = _c === void 0 ? "no favorites" : _c, _d = _b.favorites_content_list, favorites_content_list = _d === void 0 ? "no favorites" : _d;
    return {
        list: favorites_content_list,
        count: favorites_content_length,
    };
};
export var getFooterPageData = function (articleName, isNation) {
    if (articleName && isNation) {
        var TERMS_OF_USE_PAGE = "terms of use";
        var PRIVACY_POLICY_PAGE = "privacy policy";
        var CLOSED_CAPTIONING_PAGE = "closed captioning";
        var name_1 = articleName.toLowerCase();
        var footerType = void 0;
        if (name_1.includes(TERMS_OF_USE_PAGE))
            footerType = TERMS_OF_USE_PAGE;
        if (name_1.includes(PRIVACY_POLICY_PAGE))
            footerType = PRIVACY_POLICY_PAGE;
        if (name_1.includes(CLOSED_CAPTIONING_PAGE))
            footerType = "cc";
        if (footerType) {
            return { pageName: FOOTER, footerType: footerType, useUtagGlobal: true };
        }
    }
    return false;
};
// TODO: look into combining getLiveEvents & getLiveAnalyticsEvents
export var getLiveEvents = function () {
    var _a;
    return (_a = {},
        _a[SCHEDULE_RESTART] = function (_a) {
            var network = _a.network;
            var action = "livestream_start_over";
            callContextEvent(action, network);
        },
        _a[SCHEDULE_WATCH_LIVE] = function (_a) {
            var network = _a.network;
            var action = "livestream_start";
            callContextEvent(action, network);
        },
        _a);
};
export var getLiveAnalyticsEvents = function () {
    var _a;
    var tealiumEvents = getLiveEvents();
    return _a = {},
        _a[SCHEDULE_RESTART] = function (_a) {
            var network = _a.network;
            executeEvent({
                eventObj: tealiumEvents,
                event: SCHEDULE_RESTART,
                params: { network: network },
            });
        },
        _a[SCHEDULE_WATCH_LIVE] = function (_a) {
            var network = _a.network;
            executeEvent({
                eventObj: tealiumEvents,
                event: SCHEDULE_WATCH_LIVE,
                params: { network: network },
            });
        },
        _a;
};
export var getOptimizelyActiveCampaigns = function () {
    var state = getOptimizelyState();
    if (state) {
        return __assign({}, state.getExperimentStates({ isActive: true }));
    }
};
export var getOptimizelyExperimentData = function () {
    var activeCampaigns = getOptimizelyActiveCampaigns();
    if (!activeCampaigns)
        return undefined;
    var campaigns = Object.values(activeCampaigns).filter(function (campaign) { return campaign.isInExperimentHoldback !== true; });
    if (campaigns.length === 0)
        return undefined;
    var data = [];
    var segmentCampaignData = {};
    campaigns.forEach(function (campaign) {
        var _a;
        var experimentName = campaign === null || campaign === void 0 ? void 0 : campaign.experimentName;
        var variationName = (_a = campaign === null || campaign === void 0 ? void 0 : campaign.variation) === null || _a === void 0 ? void 0 : _a.name;
        var testName = experimentName + ":" + variationName;
        segmentCampaignData[experimentName] = { experimentName: experimentName, variationName: variationName };
        data.push(testName);
    });
    setSegmentOptimizelyData({ segmentCampaignData: segmentCampaignData });
    return data.join(",");
};
export var getOptimizelyState = function () { var _a, _b, _c; return (_c = (_b = (_a = window.DataLayer) === null || _a === void 0 ? void 0 : _a.getOptimizely()) === null || _b === void 0 ? void 0 : _b.get) === null || _c === void 0 ? void 0 : _c.call(_b, "state"); };
// TODO: look into combining getPlayerEvents & getPlayerAnalyticsEvents
export var getPlayerEvents = function (_a) {
    var _b;
    var profileId = _a.profileId;
    return (_b = {},
        _b[PLAYER_IDLE_PROMPT] = function () {
            var _a, _b;
            var action = "idle_prompt";
            var data = setProfileId(profileId, {
                action: action,
                page_name: (_a = window === null || window === void 0 ? void 0 : window.utag_data) === null || _a === void 0 ? void 0 : _a.page_name,
                page_type: (_b = window === null || window === void 0 ? void 0 : window.utag_data) === null || _b === void 0 ? void 0 : _b.page_type,
            });
            callEvent("" + TEALIUM_EVENT_PREFIX + action, data);
        },
        _b[PLAYER_IDLE_PROMPT_CONFIRM] = function () {
            var _a, _b;
            var action = "idle_prompt_select";
            var data = setProfileId(profileId, {
                action: action,
                page_name: (_a = window === null || window === void 0 ? void 0 : window.utag_data) === null || _a === void 0 ? void 0 : _a.page_name,
                page_type: (_b = window === null || window === void 0 ? void 0 : window.utag_data) === null || _b === void 0 ? void 0 : _b.page_type,
            });
            callEvent("" + TEALIUM_EVENT_PREFIX + action, data);
        },
        _b);
};
export var getPlayerAnalyticsEvents = function (_a) {
    var _b;
    var profileId = _a.profileId;
    var tealiumEvents = getPlayerEvents({ profileId: profileId });
    return _b = {},
        _b[PLAYER_IDLE_PROMPT] = function () {
            return executeEvent({ eventObj: tealiumEvents, event: PLAYER_IDLE_PROMPT });
        },
        _b[PLAYER_IDLE_PROMPT_CONFIRM] = function () {
            return executeEvent({
                eventObj: tealiumEvents,
                event: PLAYER_IDLE_PROMPT_CONFIRM,
            });
        },
        _b;
};
export var getPreviewPassEvents = function (_a) {
    var _b;
    var profileId = _a.profileId;
    return (_b = {},
        _b[PREVIEW_PASS_EXPIRED] = function (_a) {
            var _b, _c;
            var previewPassLength = _a.previewPassLength;
            var action = "preview_pass_expired";
            var data = setProfileId(profileId, {
                action: action,
                buildVersion: BUILD_VERSION,
                preview_pass_length: previewPassLength,
                page_name: (_b = window === null || window === void 0 ? void 0 : window.utag_data) === null || _b === void 0 ? void 0 : _b.page_name,
                page_type: (_c = window === null || window === void 0 ? void 0 : window.utag_data) === null || _c === void 0 ? void 0 : _c.page_type,
            });
            callEvent("" + TEALIUM_EVENT_PREFIX + action, data);
        },
        _b[PREVIEW_PASS_STARTED] = function (_a) {
            var _b, _c;
            var previewPassLength = _a.previewPassLength;
            var action = "preview_pass_start";
            var data = setProfileId(profileId, {
                action: action,
                buildVersion: BUILD_VERSION,
                preview_pass_length: previewPassLength,
                preview_pass_start_source: "general",
                page_name: (_b = window === null || window === void 0 ? void 0 : window.utag_data) === null || _b === void 0 ? void 0 : _b.page_name,
                page_type: (_c = window === null || window === void 0 ? void 0 : window.utag_data) === null || _c === void 0 ? void 0 : _c.page_type,
            });
            callEvent("" + TEALIUM_EVENT_PREFIX + action, data);
        },
        _b);
};
export var getProfileStartSource = function () { return window[SOURCE_PROFILE_START]; };
export var getRedesignCollectionTileType = function (data) {
    var _a, _b, _c, _d;
    var item = data === null || data === void 0 ? void 0 : data.item;
    var type = (_a = data === null || data === void 0 ? void 0 : data.item) === null || _a === void 0 ? void 0 : _a["@type"];
    var isUpcoming = (_b = window.DataLayer) === null || _b === void 0 ? void 0 : _b.isUpcomingContent(item);
    if (!isUpcoming && ((_c = window.DataLayer) === null || _c === void 0 ? void 0 : _c.isContentLive(type)))
        return "live tile";
    if ((_d = window.DataLayer) === null || _d === void 0 ? void 0 : _d.isVideoTile(type))
        return "video tile";
    return "show tile";
};
export var getRedesignHomeItemParams = function (_a) {
    var _b, _c, _d, _e, _f, _g;
    var cc = _a.cc, collectionCount = _a.collectionCount, collectionTitle = _a.collectionTitle, collectionType = _a.collectionType, containerTitle = _a.containerTitle, horizontalPosition = _a.horizontalPosition, item = _a.item, playlistLength = _a.playlistLength, state = _a.state, subtitle = _a.subtitle, title = _a.title, type = _a.type, verticalPosition = _a.verticalPosition, volume = _a.volume;
    // Sports Features
    var videoSeriesType = (_b = item === null || item === void 0 ? void 0 : item.seriesType) !== null && _b !== void 0 ? _b : null;
    var sport = "none";
    var matchup = "none";
    if (videoSeriesType === "sportingEvent") {
        sport = (_c = item === null || item === void 0 ? void 0 : item.sportTag) !== null && _c !== void 0 ? _c : sport;
        matchup = (_d = item === null || item === void 0 ? void 0 : item.name) !== null && _d !== void 0 ? _d : "none";
    }
    var homeTeam = (_e = item === null || item === void 0 ? void 0 : item.homeTeam) !== null && _e !== void 0 ? _e : "none";
    var awayTeam = (_f = item === null || item === void 0 ? void 0 : item.awayTeam) !== null && _f !== void 0 ? _f : "none";
    var sportsData = ((_g = window.DataLayer) === null || _g === void 0 ? void 0 : _g.getSportsFeatures())
        ? {
            sport: sport,
            matchup: matchup,
            home_team: homeTeam,
            away_team: awayTeam,
        }
        : {};
    return __assign({ item_type: type, item_state: state, item_container_title: containerTitle, item_vertical_position: verticalPosition, item_horizontal_position: horizontalPosition, item_title: title, item_subtitle: subtitle || "no subtitle", item_cc: cc || "cc off", item_volume: volume || "volume off", collection_title: collectionTitle || "no collection title", collection_type: collectionType || "no collection type", playlist_length: playlistLength, collection_count: collectionCount }, sportsData);
};
export var getRedesignEvents = function (_a) {
    var _b;
    var account = _a.account;
    var defaultData = { platform_version: BUILD_VERSION };
    return _b = {},
        _b[COLLECTION_IMPRESSION] = function (_a) {
            var visibleCollections = _a.visibleCollections;
            // Don't fire event without collections
            if (!Object.keys(visibleCollections !== null && visibleCollections !== void 0 ? visibleCollections : {}).length)
                return null;
            var action = "collection_item_impression";
            var data = { list3: getRedesignListVarString(visibleCollections) };
            var params = __assign(__assign({}, defaultData), data);
            return fireRedesignEvent({ action: action, account: account, params: params });
        },
        _b[COLLECTION_ITEM_SELECT] = function (data) {
            var _a;
            var action = "collection_item_select_action";
            var collectionData = getRedesignHomeItemParams(data);
            var tealiumTileType = getRedesignCollectionTileType(data);
            var list3 = (_a = data === null || data === void 0 ? void 0 : data.list3) !== null && _a !== void 0 ? _a : null;
            var params = __assign(__assign(__assign({}, defaultData), collectionData), { item_type: tealiumTileType, list3: list3 ||
                    getRedesignIndividualListVar(__assign(__assign({}, data), { tileType: tealiumTileType.replace(" tile", "") })) });
            return fireRedesignEvent({ action: action, account: account, params: params });
        },
        _b[HERO_ITEM_SELECT] = function (data) {
            var action = "hero_item_select_action";
            var collectionData = getRedesignHomeItemParams(data);
            var params = __assign(__assign({}, defaultData), collectionData);
            return fireRedesignEvent({ action: action, account: account, params: params });
        },
        _b;
};
export var getRedesignIndividualListVar = function (_a) {
    var collectionTitle = _a.collectionTitle, horizontalPosition = _a.horizontalPosition, title = _a.title, tileType = _a.tileType, verticalPosition = _a.verticalPosition;
    return "cp=" + verticalPosition + "|ip=" + horizontalPosition + "|ct=" + (collectionTitle || "no collection title") + "|tt=" + tileType + "|it=" + title;
};
export var getRedesignListVarString = function (visibleCollections) {
    if (visibleCollections === void 0) { visibleCollections = {}; }
    var visibleCollectionItems = [];
    var listVar = [];
    var formatNames = function (name) { return name && name.replace(/,/g, " "); };
    var tileType = function (item) {
        var _a, _b, _c, _d;
        var type = (_a = item === null || item === void 0 ? void 0 : item["@type"]) !== null && _a !== void 0 ? _a : null;
        var isUpcoming = (_b = window.DataLayer) === null || _b === void 0 ? void 0 : _b.isUpcomingContent(item);
        if (!isUpcoming && ((_c = window.DataLayer) === null || _c === void 0 ? void 0 : _c.isContentLive(type)))
            return "live";
        if ((_d = window.DataLayer) === null || _d === void 0 ? void 0 : _d.isVideoTile(type))
            return "video";
        return "show";
    };
    var currentActiveCollections = Object.entries(visibleCollections).reduce(function (result, _a) {
        var _b;
        var _c = __read(_a, 2), key = _c[0], value = _c[1];
        if (value.active)
            return __assign(__assign({}, result), (_b = {}, _b[key] = value, _b));
        return result;
    }, {});
    Object.values(currentActiveCollections).forEach(function (value) {
        var _a;
        (_a = value === null || value === void 0 ? void 0 : value.items) === null || _a === void 0 ? void 0 : _a.forEach(function (item) {
            var _a, _b;
            var collectionTitle = (_a = value === null || value === void 0 ? void 0 : value.headline) !== null && _a !== void 0 ? _a : "no collection title";
            var tileTitle = (_b = item === null || item === void 0 ? void 0 : item.seriesName) !== null && _b !== void 0 ? _b : item === null || item === void 0 ? void 0 : item.name;
            var visibleCollectionItem = {
                collectionPosition: value === null || value === void 0 ? void 0 : value.verticalPosition,
                collectionTitle: formatNames(collectionTitle),
                itemPosition: item === null || item === void 0 ? void 0 : item.slideIndex,
                itemTitle: formatNames(tileTitle),
                tileItemType: tileType(item),
            };
            visibleCollectionItems.push(visibleCollectionItem);
        });
    });
    visibleCollectionItems.forEach(function (item) {
        listVar.push("cp=" + item.collectionPosition + "|ip=" + item.itemPosition + "|ct=" + item.collectionTitle + "|tt=" + item.tileItemType + "|it=" + item.itemTitle);
    });
    return listVar.join(",");
};
export var getSourceAuth = function () { return window[SOURCE_AUTH]; };
export var getSourceCollectionGlobal = function () {
    var name = window[SOURCE_COLLECTION_TITLE];
    var collectionType = window[SOURCE_COLLECTION_TYPE];
    var items = window[SOURCE_COLLECTION_ITEMS];
    var selectedItem = window[SOURCE_COLLECTION_SELECTED_ITEM];
    if (name || collectionType || items) {
        deeplySetProperty(window, SOURCE_COLLECTION_TITLE, null);
        deeplySetProperty(window, SOURCE_COLLECTION_TYPE, null);
        deeplySetProperty(window, SOURCE_COLLECTION_ITEMS, null);
        deeplySetProperty(window, SOURCE_COLLECTION_SELECTED_ITEM, null);
        return {
            name: name,
            collectionType: collectionType,
            items: items,
            selectedItem: selectedItem,
        };
    }
    return null;
};
export var getSearchResultString = function (_a) {
    var genreFilterName = _a.genreFilterName, isNation = _a.isNation, itemIsLive = _a.itemIsLive, originalItem = _a.originalItem, selectedTabName = _a.selectedTabName, titleText = _a.titleText;
    var title = titleText || (originalItem === null || originalItem === void 0 ? void 0 : originalItem.name);
    if (isNation) {
        // Replace <item type> with the type of search result selected as shown:
        // ***Currently unable to implement - "live-show-video" for LIVE show search results.
        // "show-video" for VOD show search results.
        // ***Currently unable to implement - "live-show-audio" for LIVE audio show search results.
        // ***Currently unable to implement - "show-audio" for other audio show search results.
        // "personality" for Personality search results.
        // "video" for other video search results.
        var itemType = function () {
            var isAudio = false; // currently cannot determine if an item is an audio stream
            var isPersonality = (originalItem === null || originalItem === void 0 ? void 0 : originalItem.categoryType) === "personality";
            if (itemIsLive) {
                var liveShow = "live-show-"; // ignoring this line because isAudio will never be true
                /* istanbul ignore next */ return isAudio
                    ? liveShow + "audio"
                    : liveShow + "video";
            }
            if (isPersonality)
                return "personality";
            return "show-video";
        };
        return selectedTabName + ":" + genreFilterName + ":" + itemType() + ":" + title;
    }
    return "network-" + selectedTabName + ":genre-" + genreFilterName + ":" + title;
};
export var getSourceShow = function () {
    var isSourceShow = window[SOURCE_IS_SHOW];
    deeplySetProperty(window, SOURCE_IS_SHOW, null);
    return isSourceShow;
};
export var handleButtonAction = function (_a) {
    var _b, _c;
    var text = _a.text, title = _a.title, subtitle = _a.subtitle, account = _a.account;
    var action = "button_action";
    var profileId = account === null || account === void 0 ? void 0 : account.profileId;
    var program = (title || "no program title") + ":" + (subtitle || "no program subtitle");
    var data = setProfileId(profileId, {
        action: action,
        action_type: text,
        program_info: program,
        page_name: (_b = window === null || window === void 0 ? void 0 : window.utag_data) === null || _b === void 0 ? void 0 : _b.page_name,
        page_type: (_c = window === null || window === void 0 ? void 0 : window.utag_data) === null || _c === void 0 ? void 0 : _c.page_type,
    });
    callEvent("" + TEALIUM_EVENT_PREFIX + action, data);
};
export var handleSeriesButtonAction = function (_a) {
    var _b, _c;
    var text = _a.text, series = _a.series, account = _a.account, collectionTitle = _a.collectionTitle;
    var profileId = account === null || account === void 0 ? void 0 : account.profileId;
    var action = "seriespromo_button_action";
    var data = setProfileId(profileId, cleanObject({
        action: action,
        action_type: text,
        platform_version: BUILD_VERSION,
        collection_title: collectionTitle || null,
        collection_type: "no collection type",
        series: series,
        page_name: (_b = window === null || window === void 0 ? void 0 : window.utag_data) === null || _b === void 0 ? void 0 : _b.page_name,
        page_type: (_c = window === null || window === void 0 ? void 0 : window.utag_data) === null || _c === void 0 ? void 0 : _c.page_type,
    }));
    callEvent("" + TEALIUM_EVENT_PREFIX + action, data);
};
export var isTealiumLoaded = function () {
    return new Promise(function (resolve, reject) {
        var checkForUtagData = setInterval(function () {
            var _a;
            var tealiumEventsReady = (_a = window.utag) === null || _a === void 0 ? void 0 : _a.view;
            if (tealiumEventsReady) {
                clearInterval(checkForUtagData);
                checkForUtagData = null;
                resolve();
            }
        }, 500);
        setTimeout(function () {
            if (checkForUtagData) {
                clearInterval(checkForUtagData);
                checkForUtagData = null;
            }
            reject(Error("Tealium Failed To Load"));
        }, 5000);
    });
};
export function handleTealiumAnalytics(_a) {
    var event = _a.event, payload = _a.payload;
    callEvent("" + TEALIUM_EVENT_PREFIX + TealiumEventStrings[event], payload);
}
export var isTrackingEnabledForEvent = function (name) {
    var _a;
    if (!name)
        return false;
    var withTveEventsToDisable = [];
    var withoutTveEventsToDisable = [
        TEALIUM_EVENT_PREFIX + "button_click_funnels",
        TEALIUM_EVENT_PREFIX + "authentication_start",
        TEALIUM_EVENT_PREFIX + "authentication_select_provider",
        TEALIUM_EVENT_PREFIX + "authentication_incomplete",
        TEALIUM_EVENT_PREFIX + "authentication_complete",
    ];
    var disabledEvents = ((_a = window.DataLayer) === null || _a === void 0 ? void 0 : _a.isTveEnabled())
        ? withTveEventsToDisable
        : withoutTveEventsToDisable;
    var isEventEnabled = disabledEvents.indexOf(name) === -1;
    return isEventEnabled;
};
export var setProfileId = function (id, data) {
    if (id)
        return Object.assign({ "Customer ID": id }, data);
    return data;
};
export var setProfileStartSource = function (value) {
    return deeplySetProperty(window, SOURCE_PROFILE_START, value);
};
export var setSourceAuth = function (value) {
    return deeplySetProperty(window, SOURCE_AUTH, value);
};
export var setSourceCollectionGlobal = function (_a) {
    var title = _a.title, collectionType = _a.collectionType, items = _a.items, selectedItem = _a.selectedItem;
    deeplySetProperty(window, SOURCE_COLLECTION_TITLE, title);
    deeplySetProperty(window, SOURCE_COLLECTION_TYPE, collectionType);
    deeplySetProperty(window, SOURCE_COLLECTION_ITEMS, items);
    deeplySetProperty(window, SOURCE_COLLECTION_SELECTED_ITEM, selectedItem);
};
export var setSourceShow = function (value) {
    return deeplySetProperty(window, SOURCE_IS_SHOW, value);
};
export function setUtagPagePropsCallback(pageName, pageType) {
    return function () {
        if (!pageName || !pageType)
            return;
        var _a = window.utag_data, utag_data = _a === void 0 ? {} : _a;
        if (utag_data.page_name !== pageName)
            window.utag_data.page_name = pageName;
        if (utag_data.page_type !== pageType)
            window.utag_data.page_type = pageType;
    };
}
